import { TableCell } from '@/components/ui';
import { IHasValue } from '@/interfaces';

export const TableCellRowLine = ({ value }: IHasValue<number>) => (
  <TableCell className='w-0 py-1 text-neutral-400'>
    {value}
  </TableCell>
);

export default TableCellRowLine;
